module.exports = __webpack_public_path__ + "static/media/marker.06a01f8e.svg";